import { render, staticRenderFns } from "./GateTickets.vue?vue&type=template&id=4b6a9df6"
import script from "./GateTickets.vue?vue&type=script&lang=js"
export * from "./GateTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports